// extracted by mini-css-extract-plugin
module.exports = {"Item":"Committee__Item_NTWR_","Text":"Committee__Text_12yAB Committee__Item_NTWR_"};